export const SharedEntityAssociation = {
  properties: {
    SharedEntityId: {
      'bulk-upload-header': 'Id',
    },
    EntityId: {
      'bulk-upload-header': 'Parent Id',
    },
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign Negative Keyword List Association',
    },
  },
};
